import React, { Component } from 'react';
import App from '../../App';
import { withApollo } from 'react-apollo';
import { Table,Button,Icon,Row,Col,Select,Radio,Form,message,Tabs,Tooltip,Popconfirm } from 'antd';
import getUserServiceMapping from '../../queries/getUserServiceMapping'
import {returnSymbol} from '../../utils/returnSymbol'

const { TabPane } = Tabs;
class CPServiceList extends Component {
    constructor(props){
        super(props)
        this.state = {
            loading: false,
            cpServiceDataPlan: [],
            cpServiceDataAddon: []
        }
    }
    componentDidMount(){
        this.setState({ loading: true });
        this.props.client
            .query({
                query: getUserServiceMapping,
                variables: { userId: this.props.userData && this.props.userData && this.props.userData.username ? this.props.userData.username : null },
                fetchPolicy: 'no-cache',
            })
            .then(({ data }) => {
                let filterData = data.getUserServiceMapping;
                const addons = filterData.filter(item => item.type === "ADDONS");
                const plans = filterData.filter(item => item.type === "PLAN");
                this.setState({ cpServiceDataPlan: plans,cpServiceDataAddon:addons, loading: false });
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
                this.setState({ loading: false });
            });
    }
    render() {
        // console.log("this.props",this.props)
        const cpData = this.props.userData
         const columns=[
                    { title: 'Service Name', dataIndex: 'serviceName',width: '25%'},
                    { title: 'Site Option', dataIndex: 'siteOptions',width: '15%'},
                    { 
                        title: 'Annual', 
                        width: '15%',
                        render:(data)=>{
                            return(
                                 <span>{returnSymbol(parseFloat(data.boardingAmount/100),cpData.currency && cpData.currency ? cpData.currency : 'INR' )}</span>
                            )
                        }
                    },
                    { 
                        title: 'Renewal',
                        width: '15%',
                        render:(data)=>{
                            return(
                                 <span>{returnSymbol(parseFloat(data.renewalAmount/100),cpData.currency && cpData.currency ? cpData.currency : 'INR' )}</span>
                            )
                        }
                    },
                    { title: 'Note',dataIndex: 'note',width: '20%'},
                ]
        return (
            <App>
                <Tabs onChange={this.onTabChange} type="card">
                    <TabPane tab="PLANS" key="1">
                        <Table
                            size="middle"
                            columns={columns}
                            loading={this.state.loading}
                            dataSource={this.state.cpServiceDataPlan}
                        />
                    </TabPane>
                    <TabPane tab="ADDONS" key="2">
                        <Table
                            size="middle"
                            columns={columns}
                            loading={this.state.loading}
                            dataSource={this.state.cpServiceDataAddon}
                        />
                    </TabPane>
                </Tabs>
            </App>
        );
    }
}

export default withApollo(CPServiceList);